import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchLectureDeclarationsModule } from "./helpAndAssistantApi";

export interface LectureDeclarationsState {
  lecturedeclarations: Array<any>;
  status: "idle" | "loading" | "failed";
}

const initialState: LectureDeclarationsState = {
    lecturedeclarations: [],
  status: "idle",
};

export const GetLectureDeclarations = createAsyncThunk(
  "lectureDeclarations/fetchLectureDeclarations",
  async (data:any) => {
    const response = await fetchLectureDeclarationsModule(data);
    return response;
  }
);

export const lectureDeclarationsSlice = createSlice({
  name: "LectureDeclarations",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetLectureDeclarations.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetLectureDeclarations.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(GetLectureDeclarations.fulfilled, (state, action) => {
        state.status = "idle";
        state.lecturedeclarations = action.payload.lecture;
      });
  },
});

export const {} = lectureDeclarationsSlice.actions;

export const selectLectureDeclarations = (state: RootState) => {
  return state.LectureDeclarations.lecturedeclarations;
};

export default lectureDeclarationsSlice.reducer;